<template>
    <div v-if="loadingLayersList">
        <NavBar noleft="true" />
        <LayerView :layer_id="id" :project_id="hashid" />
    </div>
</template>

<script>

import NavBar       from "../NavBar";
import LayerView    from "../PVComponents/LayerView";

export default {
    name: "ProjectView",
    props: ['project_id', 'layer_id'],
    data () {
        return {
            loadingLayersList: false,
            hashid: null,
            id: null
        }
    },
    computed:{
        projects () {
            return this.$store.getters.projects;
        },
        projectsLoaded(){
            return this.$store.getters.projectsLoaded
        }
    },
    components:{
        NavBar,
        LayerView
    },
    created() {
        this.$vuetify.theme.dark = true;

        let prjkey, lyrkey;

        this.hashid = this.project_id;
        this.id = this.layer_id;

        if (!this.projectsLoaded){
            this.$store.dispatch('getProjects')
            .then(() => {
                if (this.projects.length != 0){
                    prjkey = Object.keys(this.projects).find(k=>this.projects[k].hashid==this.project_id);
                    if (typeof prjkey != 'undefined'){
                        lyrkey = Object.keys(this.projects[prjkey].layers).find(k=>this.projects[prjkey].layers[k].id==this.id);
                        if(typeof lyrkey != 'undefined'){
                            this.loadingLayersList = true;
                        }
                        else{
                            this.id = this.projects[prjkey].layers[0].id;
                            history.pushState({}, null, '/view/' + this.hashid + '/' + this.id);
                            this.loadingLayersList = true;
                        }
                    }
                    else{
                        this.hashid = this.projects[0].hashid;
                        this.id = this.projects[0].layers[0].id;
                        history.pushState({}, null, '/view/' + this.hashid + '/' + this.id);
                        this.loadingLayersList = true;
                    }
                }
                else{
                    this.$router.push('/');
                }
            })
            .catch(() => {});
        }
        else{
            if (this.projects.length != 0){
                prjkey = Object.keys(this.projects).find(k=>this.projects[k].hashid==this.project_id);
                if (typeof prjkey != 'undefined'){
                    lyrkey = Object.keys(this.projects[prjkey].layers).find(k=>this.projects[prjkey].layers[k].id==this.id);
                    if(typeof lyrkey != 'undefined'){
                        this.loadingLayersList = true;
                    }
                    else{
                        this.id = this.projects[prjkey].layers[0].id;
                        history.pushState({}, null, '/view/' + this.hashid + '/' + this.id);
                        this.loadingLayersList = true;
                    }
                }
                else{
                    this.hashid = this.projects[0].hashid;
                    this.id = this.projects[0].layers[0].id;
                    history.pushState({}, null, '/view/' + this.hashid + '/' + this.id);
                    this.loadingLayersList = true;
                }
            }
            else{
                this.$router.push('/');
            }
        }
    }
};
</script>
